'use client';
import { useEffect, useMemo, useState } from 'react';
import { GrossUpSeries, ISeries } from './gross-up-series';
import {
  CustomSeriesOptionsType,
  IBaseChartProps,
} from '../base-chart/interface';

/**
 * Verifica se a série é de gross up
 * e se a diferença entre a data do primeiro quote e a data do primeiro quote da série com gross-up é maior que 1 mes.
 * Caso seja, recarrega a série alterando a data de inicio das cotas.
 * Isso garante que o cálculo de gross up seja feito corretamente.
 */
export const withGrossUpReloadSeries =
  <T extends IBaseChartProps>(Component: React.FC<T>) =>
  (props: T) => {
    const [seriesWithFizGrossUp, setSeriesWithFizGrossUp] = useState<ISeries[]>(
      []
    );
    const [loadingGrossUp, setLoadingGrossUp] = useState(false);

    const seriesWithGrossUp = useMemo(
      () => (seriesWithFizGrossUp.length ? seriesWithFizGrossUp : props.series),
      [seriesWithFizGrossUp, props.series]
    );

    useEffect(() => {
      const grossUpHandler = new GrossUpSeries(
        props.series as any,
        props.period as any
      );

      if (!grossUpHandler.shouldProcess()) {
        setSeriesWithFizGrossUp([]);
        return;
      }

      setLoadingGrossUp(true);

      grossUpHandler
        .process()
        .then(setSeriesWithFizGrossUp)
        .finally(() => {
          setLoadingGrossUp(false);
        });
    }, [props.series, props.period]);

    return (
      <Component
        {...props}
        series={seriesWithGrossUp as CustomSeriesOptionsType}
        loading={props?.loading || loadingGrossUp}
      />
    );
  };
